<template>
<div>
        <nav>
            <div class="navregular">
                <router-link to="/records">View Records</router-link>
                <!-- <a data-name="info" data-domain="chinesetypearchive" data-tld="com" href="#" class="cryptedmail" onclick="window.location.href = 'mailto:' + this.dataset.name + '@' + this.dataset.domain + '.' + this.dataset.tld"></a>-->
                <a href="https://forms.gle/fgGTa9P9vA1jVJMS7" target="_blank">Submit</a>
            </div>
            <div class="navmobile">
                <span class="menubutton" @click="menuButtonClicked"></span>
                <router-link to="/">The Chinese Type Archive</router-link>
                <span></span>
            </div>
        </nav>

        <header>
        </header>
        
        <section class="mainbody">
            <div class="about">
                <div class="col_ch">
                        <p class="marginalia">中文</p>
                        <p>字體資料庫（{{ this.$store.state.currentVersion }}）搜集各種與中文字型設計相關的資源並將其分類，讓廣大設計師擁有更加便利的渠道的檔案網站。字體資料庫的目的是讓來自世界各地的設計師：</p>
                        <ol>
                        <li>發展有關中文平面設計概念，字型和其他相關的詞彙</li>
                        <li>收藏相關的設計範例</li>
                        <li>提供中文和其他語系的字體設計系統的切入點</li>
                        </ol>
                        <p>作為一個資料庫，我們利用了大量記載設計歷史，使用方法，字體演變的收藏。字體資料庫結合許多相關材料來集中關注在中文字型設計，並將會在未來涵蓋字型設計分析和數據發布的工具和方法。</p>
                        <p>這是一個由志願者設計師合辦的正在進行中的項目，因此，字體資料庫會存在漏洞及誤差，並且仍需完善。我們隨時歡迎設計師們參與，提供新的信息，指出錯誤。</p>
                        <p>字體資料庫由AIGA DEC和帕森斯設計學院贊助支持。所有材料信息來自於Synoptic Office。</p>
                        <h5>項目負責人</h5>
                        <ul>
                            <li>朴瑜俊</li>
                            <li>林欣榮</li>
                        </ul>
                        <h5>編者</h5>
                        <ul>
                            <li>王乃謙</li>
                            <li>黃麗霓</li>
                        </ul>
                        <h5>項目團隊及撰稿人</h5>
                        <ul>
                            <li>王藝霏</li>
                            <li>王弋戈</li>
                            <li>鄭海彤</li>
                            <li>陳米</li>
                            <li>張貝妮</li>
                            <li>關紫嫣</li>
                            <li>唐令行</li>
                            <li>Jack Rieger</li>
                            <li>周梓容</li>
                            <li>李煜</li>
                            <li>張恩博</li>
                            <li>艾傑諾</li>

                        </ul>
                        <p class="topspacing">期待你的參與<br />聯絡我們：<a href="mailto:info@chinesetypearchive.com">info@chinesetypearchive.com</a></p>
                        <!-- <p class="topspacing">最後更新：2020-10-26</p> -->
                        <p class="topspacing"><a href='https://mailchi.mp/48d1c2d2b46a/cta' target="_blank">訂閱電子通訊</a></p>
                        
                </div>
                <div class="col_eng">
                        <p class="marginalia">EN</p>
                        <p>The Chinese Type Archive ({{ this.$store.state.currentVersion }}) compiles and catalogs resources related to Chinese typography to make them open and accessible to the widest possible audience of designers. Its aim is to support designers who use Chinese typography by:</p>
                    <ol>
                    <li>Developing descriptors for concepts, typefaces, and related entities</li>
                    <li>Archiving related and relevant visual examples</li>
                    <li>Providing points of entry through translation and highlighting relationships that may be equivalent and not equivalent to other typographic systems</li>
                    </ol>
                    <p>We utilize a broad approach towards collecting with the aim of capturing design history and fostering the dialogue, use, and evolution of Chinese typography in a globalized context. The initiative focuses on Chinese typography, proper, and incorporates relevant material adjacent to it. Future efforts include tools and methods for typographic analysis and data publishing.</p>
                    <p>The Chinese Type Archive is an ongoing, collaborative effort run by volunteers. Because of this, the data is incomplete and contains omissions and errors. We welcome collaborators, submissions, and corrections.</p>
                    <p>This project is funded in part by the American Institute of Graphic Arts Design Educators Community grant and the Parsons School of Design General Research Fund. Material support comes from Synoptic Office.</p>
                    <h5>Project Lead</h5>
                    <ul>
                        <li>Caspar Lam</li>
                        <li>YuJune Park</li>
                    </ul>
                    <h5>Editors</h5>
                    <ul>
                        <li>Mac Wang</li>
                        <li>Stephanie Winarto</li>
                    </ul>
                    <h5>Project Team &amp; Contributors</h5>
                    <ul>
                        <li>Yifei Wang</li>
                        <li>Yige Wang</li>
                        <li>Haitong Zheng</li>
                        <li>Mi Chen</li>
                        <li>Claire Zhang</li>
                        <li>Karen Kwan</li>
                        <li>Dustin Tong</li>
                        <li>Jack Rieger</li>
                        <li>Antoinette Chow</li>
                        <li>Yu Li</li>
                        <li>Bert Zhang</li>
                        <li>Jarrod Armour</li>
                    </ul>
                    <a name="submit"></a>
                    <p class="topspacing">And Contributors Like You. For more information, contact us at <a href="mailto:info@chinesetypearchive.com">info@chinesetypearchive.com</a></p>
                    <!-- <p class="topspacing">Last updated: 2020-10-26</p> -->
                    <p class="topspacing"><a href='https://mailchi.mp/48d1c2d2b46a/cta' target="_blank">Sign-up for news from the Archive.</a></p>
                    

                </div>
            </div>
            <div class="about">
                    <footer class="col_ch">
                        <p>© 字體資料庫。字體資料庫採用<a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank">創用 CC 姓名標示-非商業性-禁止改作 4.0 國際 授權條款授權</a>。</p>
                    </footer>
                    <footer class="col_eng">
                        <p>© Chinese Type Archive. The Chinese Type Archive is licensed under the <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank">Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License</a>.</p>
                    </footer>
            </div>
        </section>
</div>
</template>

<script>


export default {
  name: 'AboutViewSide',
  components: {
  },
  methods: {
    menuButtonClicked(){
      if(this.$store.state.menuOpened){
        this.$store.state.menuOpened=false;
      }else {
        this.$store.state.menuOpened=true;
      }
    }
  }
}
</script>

<style>
</style>
